import { auth, db, storage } from '@/firebase'
import { updateProfile, updateEmail } from 'firebase/auth'
import {
  setDoc,
  doc,
  getDoc,
  serverTimestamp,
  updateDoc,
  collection,
  getDocs,
  DocumentData,
} from 'firebase/firestore'
import { uploadString, ref, getDownloadURL } from 'firebase/storage'
import { Dayjs } from 'dayjs'
import { UserType } from '@/types/user'

export const createUserDb = async (
  id: string,
  name: string,
  email: string,
  gender: string,
  birthday: Dayjs,
) => {
  const docRef = doc(db, 'users', id)
  const docSnap = await getDoc(docRef)
  const formattedBirthday = birthday.format('YYYY/MM/DD')
  try {
    if (docSnap.exists()) {
      return
    } else {
      await setDoc(doc(db, 'users', id), {
        id,
        name,
        email,
        gender,
        birthday: formattedBirthday,
        createdAt: serverTimestamp(),
      })
    }
  } catch (error) {
    return error
  }
}

export const updateUserName = async (
  name: string,
  id: string,
  successCb: () => void,
  errCb: () => void,
) => {
  if (auth.currentUser) {
    try {
      await updateProfile(auth.currentUser, {
        displayName: name,
      })
      await updateDoc(doc(db, 'users', id), {
        name,
      })
      successCb()
    } catch (error) {
      errCb()
    }
  } else {
    errCb()
  }
}

export const updateUserEmail = async (
  email: string,
  id: string,
  successCb: () => void,
  errCb: () => void,
) => {
  if (auth.currentUser) {
    try {
      await updateEmail(auth.currentUser, email)
      await updateDoc(doc(db, 'users', id), {
        email,
      })
      successCb()
    } catch (error) {
      errCb()
    }
  } else {
    errCb()
  }
}

export const getUserInfo = async () => {
  const docRef = doc(db, 'users', auth.currentUser.uid)
  const docSnap = await getDoc(docRef)
  const userInfo = docSnap.data()
  return userInfo
}
